module.exports = __webpack_public_path__ + "img/CS-UL-II_Overview-Spare_4.ac4b6697.jpg";